import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { LoginFailure, LoginRequest, LoginSuccess } from './actions';
import { IntegrationTokenPayloadInfo } from '@models/swagger';
import { LoginParams, LoginService } from './service';
import { UpdateRtkJwt, UpdateTkJwt } from '@store/flow-data/general';

@Injectable()
export class LoginEffects {
  private readonly actions$ = inject(Actions);
  private readonly loginService = inject(LoginService);

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoginRequest),
      switchMap(({ body, parameters }: { body: IntegrationTokenPayloadInfo; parameters?: LoginParams }) =>
        this.loginService.login(body, parameters).pipe(
          switchMap(data => [
            UpdateTkJwt({ data: data.token }),
            UpdateRtkJwt({ data: data.refreshToken }),
            LoginSuccess({ data }),
          ]),
          catchError(error => of(LoginFailure({ error })))
        )
      )
    )
  );

}
